import React from 'react'
import Drawer from 'src/components/MUI/Drawer/Drawer'
import DrawerHeader from 'src/components/MUI/Drawer/DrawerHeader'
import DrawerActions from 'src/components/MUI/Drawer/DrawerActions'
import Button from 'src/components/MUI/Button'
import useModal from 'src/hooks/useModal'

import AddressForm from './AddressForm' // Adjust import path as necessary

interface AddressEditorModalProps {
  onComplete?: (data: unknown) => void
}

const AddressEditorModal: React.FC<AddressEditorModalProps> = ({
  onComplete,
}) => {
  // Handle both discriminators like the other drawer components
  const shippingModal = useModal('addressEditorModal', 'shippingAddress')
  const billingModal = useModal('addressEditorModal', 'billingAddress')

  // Determine which modal is open and use its data
  const activeModal = shippingModal.isOpen
    ? shippingModal
    : billingModal.isOpen
    ? billingModal
    : null

  const isOpen = activeModal?.isOpen || false
  const handleClose = activeModal?.handleClose || (() => {})
  const modalData = activeModal?.data

  const addressId = modalData?.addressId as string | undefined
  const discriminator = modalData?.discriminator as
    | 'shippingAddress'
    | 'billingAddress'
    | undefined

  return (
    <Drawer anchor="right" open={isOpen} onClose={handleClose}>
      <DrawerHeader
        title={addressId ? 'Edit Address' : 'Create Address'}
        onClose={handleClose}
      />
      <div className="h-full w-[800px] p-3">
        <AddressForm
          id={addressId}
          onClose={handleClose}
          onComplete={onComplete}
          discriminator={discriminator}
        />
      </div>
      <DrawerActions
        className="gap-1"
        leftActions={
          <Button variant="text" color="black" onClick={handleClose}>
            CANCEL
          </Button>
        }
        rightActions={
          <Button
            type="submit"
            form="addressForm"
            variant="contained"
            color="primary"
          >
            {addressId ? 'SAVE' : 'CREATE'}
          </Button>
        }
      />
    </Drawer>
  )
}

export default AddressEditorModal
